import en from './en';
import cn from './cn';
import jp from './jp';
import ko from './ko';
export default {
    EN: en,
    CN: cn,
    JP: jp,
    KO: ko
}
